import { render, staticRenderFns } from "./Manifest.vue?vue&type=template&id=0c5e9729"
import script from "./Manifest.vue?vue&type=script&lang=js"
export * from "./Manifest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports